import { CONTENT_TYPES } from "../typings/document-types";
import { HeadlessAgent, HeadlessResponse } from "./UmbracoClient";

function editorAdapter(editor: any)
{
    const settings = editor.items?.find(item => item.content.contentType === "AreaSettings")?.settings.properties;

    const controls = editor.items.map(item =>
    {
        return {
            _contentType: item.content.contentType,
            ...item.content.properties
        };
    });
    return {
        grid: editor.columnSpan,
        controls: controls,
        config: {
            alignmentY: settings?.alignmentY,
            readMore: settings?.readMore,
            unpublished: settings?.unpublished
        },
        styles: {
            "background-color": settings?.backgroundColor,
            color: settings?.color,
            "background-image": settings?.backgroundImage,
        }
    };
}

function rowAdapter(row: any)
{
    const name = row.content.contentType;
    // const areaAlias = row.areas.alias;
    const areas = row.areas.map((area: any) =>
    {
        return editorAdapter(area);
    });
    const { properties } = row.settings;

    return {
        name: name,
        areas: areas,
        config: {
            "spacing-bottom": properties.spacingBottom,
            "spacing-top": properties.spacingTop,
            "background-image": properties.backgroundImage,
            width: properties.width,
            readMore: properties.readMore,
            unpublished: properties.unpublished
        },
        styles: {
            "background-color": properties.backgroundColor,
            color: properties.color,
            "background-image": properties.backgroundImage,
        }
    };
}

function bodyTextAdapter(bodyText: any)
{
    if (!bodyText) return null;
    const items = bodyText.items;

    return {
        name: "1 column layout",
        sections: [{
            grid: 12,
            rows: items.map((item: any) => rowAdapter(item))
        }],
    };
}

function footerAdapter(footer: any)
{
    if (!footer) return null;
    const footerItems = footer.items;
    return footerItems.map((item: any) =>
    {
        switch (item.content.contentType)
        {
            case "footerRichText":
                return {
                    _contentType: item.content.contentType,
                    bodyText: item.content.properties.bodyText.markup,
                    heading: item.content.properties.heading,
                };
            case "footerShortcuts":
                return {
                    _contentType: item.content.contentType,
                    heading: item.content.properties.heading,
                    shortcuts: item.content.properties.shortcuts,
                    button: item.content.properties.button?.items
                };
        }
    });
}

export function contentByPathAdapter<T extends CONTENT_TYPES>(response: any): HeadlessResponse<T>
{
    const internalRedirectId: any | null = response.properties?.internalRedirectId;
    const contentToRender: any = internalRedirectId ? internalRedirectId : response;
    if (contentToRender)
    {
        const legacyResult = {
            ...contentToRender.properties,
            _contentType: contentToRender.contentType,
            _id: contentToRender.id,
            _name: contentToRender.name,
            _url: contentToRender.route?.path || "",
            bodyText: bodyTextAdapter(contentToRender.properties?.bodyText),
            footer: footerAdapter(contentToRender.properties?.footer)
        } as T;

        return {
            statusCode: response.status || 200,
            result: legacyResult,
            agent: HeadlessAgent.Server,
            redirectUrl: response.redirectUrl ?? undefined
        };
    }

    return {
        statusCode: 404,
        statusText: "Not Found",
        result: {} as T,
        agent: HeadlessAgent.Server,
        redirectUrl: undefined
    };
}

